<div fxLayout="column">
    <div fxLayout="row wrap">
        <ng-container *ngFor="let predMessage of predefinedMessages">
            <mat-icon
            class="mr-1 ml-1"
            *ngIf="predMessage.icon"
            [matTooltip]="predMessage.message"
            [svgIcon]="getIcon(predMessage.icon)"
            [ngClass]="getClass(predMessage.icon)"
            [matMenuTriggerFor]="predefinedMessageMenu">
            </mat-icon>
            <mat-menu #predefinedMessageMenu="matMenu">
                <button mat-menu-item (click)="select(predMessage)">
                  <span>{{'select' | translate}}</span>
                </button>
                <button mat-menu-item (click)="deleteMessage(predMessage)">
                  <span>{{'delete' | translate}}</span>
                </button>
              </mat-menu>
        </ng-container>
    </div>
    <div fxLayout="row">
        <textarea fxFlex="90" class="text-area" [value]="message.message" (input)="setContent($event)"></textarea>
        <div fxFlex="10" class="icon-area" fxLayout="column" fxLayoutAlign="space-around center">
            <button mat-icon-button [matTooltip]="'save' | translate" [disabled]="message.message == ''"
                (click)="saveMessage()"><mat-icon svgIcon="save"></mat-icon></button>
            <button mat-icon-button [matTooltip]="'send' | translate" [disabled]="message.message == '' || !(channelService.receiversObservable$ | async).length"
                (click)="confirmMessage()"><mat-icon svgIcon="send"></mat-icon></button>
        </div>
    </div>
</div>